import { useQuery } from "@tanstack/react-query";
import { Bell, RefreshCw, Search, Sparkles } from "lucide-react";
import { useLocation } from "react-router-dom";

import { BreadcrumbTrail } from "@/hooks/use-breadcrumbs";
import { ThemeToggle } from "@/components/navigation/theme-toggle";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { navigationItems } from "@/lib/navigation";
import { fetchNavigationSummary } from "@/services/mock-api";

export function TopNav() {
  const location = useLocation();
  const currentItem = navigationItems.find((item) => item.path === location.pathname);
  const summaryQuery = useQuery({
    queryKey: ["navigation-summary"],
    queryFn: fetchNavigationSummary,
  });

  return (
    <header className="sticky top-0 z-30 border-b border-border/70 bg-background/88 backdrop-blur-xl">
      <div className="flex flex-col gap-4 px-4 py-4 md:px-6">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <BreadcrumbTrail />
            <div className="mt-2 flex items-center gap-3">
              <h1 className="truncate font-serif text-2xl font-bold tracking-tight text-foreground">
                {currentItem?.title ?? "PRIMA"}
              </h1>
              {summaryQuery.data ? (
                <Badge variant="outline">{summaryQuery.data.activeRole}</Badge>
              ) : null}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" aria-label="Cari">
              <Search className="size-4" />
            </Button>
            <Button variant="outline" size="icon" aria-label="Muat ulang">
              <RefreshCw className="size-4" />
            </Button>
            <Button variant="outline" className="hidden md:inline-flex">
              <Sparkles className="size-4" />
              Lab AI
            </Button>
            <Button variant="outline" size="icon" aria-label="Peringatan">
              <Bell className="size-4" />
            </Button>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
